import { getMonthsBetween } from '@ha/date';

import { FilterBuilder } from '../Types';

const minimumStayMonthsBuilder: FilterBuilder = params => {
  if (params.startDate && params.endDate) {
    return `(minimumStayMonths<=${getMonthsBetween(
      params.startDate,
      params.endDate,
    )})`;
  }

  return '';
};

export default minimumStayMonthsBuilder;
